import { ColorsType } from '../types'

const Palette = {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    greyGorilla: '#2b2c2d',
    greyRhino: '#3D3D3D',
    greyElephant: '#535556',
    greyKoala: '#74787a',
    greyHippo: '#888d90',
    greyQuokka: '#b5b9ba',
    greyDolphin: '#d2d5d6',
    greySeal: '#e5e5e5',
    greyMouse: '#eaeaea',
    greyErmine: '#f4f5f5',
    westblue: '#043de2',
    westblueTint: '#0a70f3',
    indigo: '#3c62c3',
    ladybird: '#ab2b2b',
    engineRed: '#C63400',
    cricketGreen: '#2c3e02',
    java: '#13b4c3',
    hollywoodCerise: '#F400AB',
    sunshineYellow: '#E4C300',
    canaryYellow: '#FFB506',
    fantaOrange: '#FF8900',
    olympics: {
        green: '#0A5158',
        white: '#fff',
        yellow: '#FDED00',
        border: '#468084',
    },
} as const

export type TheWestPalette = typeof Palette

export type TheWestColourMap = ColorsType<TheWestPalette>

export const colors: TheWestColourMap = {
    brand: Palette.westblue,
    section: Palette.westblue,
    palette: Palette,
    background: {
        primary: Palette.white,
        secondary: Palette.white,
    },
    text: {
        primary: Palette.black,
        secondary: Palette.greyElephant,
        tertiary: Palette.greyGorilla,
        heading: Palette.greyGorilla,
    },
    actions: {
        link: {
            default: Palette.greyGorilla,
            hover: Palette.westblue,
            focus: Palette.westblue,
            active: Palette.westblue,
        },
        button: {
            primary: {
                text: {
                    default: Palette.white,
                    hover: Palette.westblue,
                    focus: Palette.white,
                    active: Palette.white,
                },
                background: {
                    default: Palette.westblue,
                    hover: Palette.white,
                    focus: Palette.greyGorilla,
                    active: Palette.greyGorilla,
                },
                border: {
                    default: Palette.westblue,
                    hover: Palette.white,
                    focus: Palette.greyGorilla,
                    active: Palette.greyGorilla,
                },
            },
        },
    },
    icons: {
        default: Palette.greyHippo,
        hover: Palette.westblue,
    },
    borders: {
        primary: Palette.greyDolphin,
        secondary: Palette.greyGorilla,
    },
}
